import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID } from '@angular/core';

import { COUNTRY_ID } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/l10n/country';
import { LocaleStaticLoaderModule } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/l10n/locale-static-loader';
import { TranslateStaticLoader } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/l10n/translate-static-loader';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateModule } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/l10n/translation';
import { IconModule } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/components/icons';
import { AlertModule } from '@sailpoint-priv/armada-angular/src/sailpoint/angular/components/alert';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import {
  LoadingMaskModule
} from '@sailpoint-priv/armada-angular/src/sailpoint/angular/components/loading-mask';
import { DashboardLayoutModule } from "@shared/layouts/dashboard-layout";
import { SidebarModule } from "@shared/layouts/sidebar/sidebar.module";
import { HeaderModule } from "@shared/layouts/header/header.module";
import { AuthInterceptor } from "@core/interceptors/auth.interceptor";
import { HttpErrorInterceptor } from "@core/interceptors/http-error.interceptor";
import { ApiUrlInterceptor } from "@core/interceptors/api-url.interceptor";

import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MarkdownModule } from 'ngx-markdown';
import { SecurityContext } from '@angular/core';

// Prism imports for syntax highlighting
import 'prismjs';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-markup'; // XML/HTML
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-highlight/prism-line-highlight';

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AmplifyAuthenticatorModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LocaleStaticLoaderModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateStaticLoader
            },
            defaultLanguage: 'en',
        }),
        NgbModule,
        NgbPopoverModule,
        AlertModule,
        IconModule,
        LoadingMaskModule,
        DashboardLayoutModule,
        SidebarModule,
        HeaderModule,
        MonacoEditorModule.forRoot(),
        MarkdownModule.forRoot({
            sanitize: SecurityContext.NONE
        })], providers: [
        { provide: LOCALE_ID, useValue: 'en' },
        { provide: COUNTRY_ID, useValue: 'US' },
        { provide: HTTP_INTERCEPTORS, useClass: ApiUrlInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
